"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

var _block_raw_name = require("../from-dictionary/block_raw_name");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _getAcssClasses = function _getAcssClasses(block, predicates, fragment, i) {
  var thisBlock = block;
  var isRawClasses = false;
  var classNames = fragment.split(/(?!\(.*)\s(?![^(]*?\))/g).reduce(function (acc, el) {
    var classFragment = el;
    var classFragmentArr = [];
    var classesString = '';

    if ((0, _lodash.eq)(classFragment.substr(-1), ':')) {
      classFragment = classFragment.slice(0, -1);
      classFragmentArr = (0, _lodash.without)((0, _lodash.split)(classFragment, ':', 2), '') || [];

      if ((0, _lodash.isEmpty)(classFragmentArr)) {
        classFragmentArr[0] = classFragment;
      }

      if (!predicates.shift()) {
        if (classFragmentArr.length < 2) {
          return acc;
        }

        var _classFragmentArr = classFragmentArr;

        var _classFragmentArr2 = _slicedToArray(_classFragmentArr, 2);

        classFragment = _classFragmentArr2[1];
      } else {
        var _classFragmentArr3 = classFragmentArr;

        var _classFragmentArr4 = _slicedToArray(_classFragmentArr3, 1);

        classFragment = _classFragmentArr4[0];
      }
    } else if ((0, _lodash.eq)(classFragment.substr(-1), '#')) {
      classFragment = predicates.shift();

      if (!classFragment) {
        return acc;
      }
    }

    var classFragmentsInBrackes = classFragment.match(/\(([^)]+)\)/);

    if (classFragmentsInBrackes) {
      // console.log('this fragments in brackets ', classFragmentsInBrackes[1]);
      classFragment = _getAcssClasses(block, [], classFragmentsInBrackes[1], 1);
      isRawClasses = true;
    }

    classesString = !isRawClasses ? "".concat(thisBlock).concat(classFragment, " ") : "".concat(classFragment, " ");

    if ((0, _lodash.eq)(classesString, "".concat(_block_raw_name.$uiA, " "))) {
      classesString = '';
    }

    return "".concat(acc).concat(classesString);
  }, '');
  return classNames;
};

var _getBlockClasses = function _getBlockClasses(block, predicates, fragment, i) {
  var useElementAsBlock = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var element = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  // console.log('block ', block);
  var thisBlock = block;
  var thisElement = element;
  var classNames = fragment.split(/(?!\(.*)\s(?![^(]*?\))/g).reduce(function (acc, el) {
    var classFragment = el;
    var classFragmentArr = [];
    var classesString = '';

    if ((0, _lodash.eq)(classFragment.substr(-1), ':')) {
      classFragment = classFragment.slice(0, -1);
      classFragmentArr = (0, _lodash.without)((0, _lodash.split)(classFragment, ':', 2), '') || [];

      if ((0, _lodash.isEmpty)(classFragmentArr)) {
        classFragmentArr[0] = classFragment;
      }

      if (!predicates.shift()) {
        if (classFragmentArr.length < 2) {
          return acc;
        }

        var _classFragmentArr5 = classFragmentArr;

        var _classFragmentArr6 = _slicedToArray(_classFragmentArr5, 2);

        classFragment = _classFragmentArr6[1];
      } else {
        var _classFragmentArr7 = classFragmentArr;

        var _classFragmentArr8 = _slicedToArray(_classFragmentArr7, 1);

        classFragment = _classFragmentArr8[0];
      }
    } else if ((0, _lodash.eq)(classFragment.substr(-1), '#')) {
      classFragment = predicates.shift();

      if (!classFragment) {
        return acc;
      }
    }

    var classFragmentsInBrackes = classFragment.match(/\(([^)]+)\)/);

    if (classFragmentsInBrackes) {
      // console.log('this fragments in brackets ', classFragmentsInBrackes[1]);
      classFragment = _getBlockClasses(block, [], classFragmentsInBrackes[1], 1, thisElement ? true : false, thisElement);
    }

    switch (classFragment.substr(0, 2)) {
      case '__':
        classesString = "".concat(classFragment);
        thisBlock = "".concat(thisBlock).concat(classesString);
        thisElement = thisBlock;
        break;

      case '--':
        if (useElementAsBlock) {
          thisBlock = thisElement;
        }

        classesString = " ".concat(thisBlock).concat(classFragment);
        break;

      default:
        classesString = "".concat(classFragment, " ");
    }

    return "".concat(acc).concat(classesString);
  }, i === 0 ? thisBlock : '');
  return classNames;
}; // TODO: Eugene should consider another function with auto key and memoization limit


var getBlock = function getBlock(blockName) {
  return (0, _lodash.memoize)(function (elements) {
    for (var _len = arguments.length, predicates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      predicates[_key - 1] = arguments[_key];
    }

    // console.log('I am running...------------------------------------------------------');
    var thisBlock = blockName;
    var classProcessor = (0, _lodash.eq)(blockName, _block_raw_name.$uiA) ? _getAcssClasses : _getBlockClasses;
    return elements.reduce(function (acc, el, i) {
      return "".concat(acc, " ").concat(classProcessor(thisBlock, predicates, el, i));
    }, '').trim().replace(/\s+/g, ' ');
  }, function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    // console.log(`${blockName}|${values(args).join('|')}`);
    return "".concat(blockName, "|").concat((0, _lodash.values)(args).join('|'));
  });
};

var _default = getBlock;
exports.default = _default;